import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatSelectModule } from '@angular/material/select'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatTableModule } from '@angular/material/table'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import moment from 'moment/moment'
import { MotoristaImpedimentoService } from '../../../core/services/driver/motorista-impedimento/motorista-impedimento.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { DialogConfirmComponent } from '../../../shared/components/dialog-confirm/dialog-confirm.component'
import { ImpedimentoFormDialogComponent } from './impedimento-form-dialog/impedimento-form-dialog.component'
import { DriverAutocompleteComponent } from '../../../shared/components/driver-autocomplete/driver-autocomplete.component'
import { TIPOS_IMPEDIMENTO } from '../../../core/models/motorista-impedimento.model'

@Component({
  selector: 'impedimentos-motorista',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    DriverAutocompleteComponent,
    MatDatepickerModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatTableModule,
    MatDialogModule,
  ],
  templateUrl: './impedimentos-motorista.component.html',
  styleUrl: './impedimentos-motorista.component.scss',
  standalone: true,
})
export class ImpedimentosMotoristaComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private impedimentoService: MotoristaImpedimentoService,
    private snackbar: SnackbarCustomService,
    private dialog: MatDialog,
  ) {}

  displayedColumns = ['motorista', 'tipo', 'periodo', 'observacao', 'acoes']

  tiposImpedimento = TIPOS_IMPEDIMENTO

  loading = false
  impedimentos: any[] = []
  // Mensagem do back: sempre diz o período aplicado (datas vazias = hoje até +30 dias).
  // Sem ela, um impedimento fora dessa janela some da lista sem explicação.
  periodoAplicado = ''
  // Muda a cada limpeza pra recriar o autocomplete de motorista (@for track no template).
  limparMotorista = 0

  filtro: FormGroup = new FormGroup({})

  ngOnInit(): void {
    this.createFiltro()
    this.buscar()
  }

  createFiltro(): void {
    this.filtro = this.formBuilder.group({
      motoristaId: [null],
      tipoImpedimentoId: [null],
      dataInicio: [''],
      dataFim: [''],
    })
  }

  onMotoristaChange(motorista: any | null): void {
    this.filtro.patchValue({ motoristaId: motorista?.id ?? null })
  }

  limparFiltro(): void {
    this.filtro.reset({ motoristaId: null, tipoImpedimentoId: null, dataInicio: '', dataFim: '' })
    this.limparMotorista++
    this.buscar()
  }

  buscar(): void {
    const v = this.filtro.value
    this.loading = true
    this.impedimentoService
      .search({
        dataInicio: v.dataInicio ? moment(v.dataInicio).format('DD/MM/YYYY') : undefined,
        dataFim: v.dataFim ? moment(v.dataFim).format('DD/MM/YYYY') : undefined,
        tipoImpedimentoId: v.tipoImpedimentoId || null,
        motoristaId: v.motoristaId || null,
      })
      .subscribe({
        next: (res: any) => {
          this.impedimentos = res.data ?? []
          this.periodoAplicado = res.message ?? ''
          this.loading = false
        },
        error: (err: any) => {
          this.snackbar.errorRequest(err)
          this.loading = false
        },
      })
  }

  novoImpedimento(): void {
    const dialogRef = this.dialog.open(ImpedimentoFormDialogComponent, {
      width: '620px',
    })
    dialogRef.afterClosed().subscribe((criado: boolean) => {
      if (criado) this.buscar()
    })
  }

  remover(item: any): void {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Remover impedimento',
        message: `Remover "${item.tipo}" de ${item.motoristaNome} (${item.resumo})? Pra corrigir depois, é preciso lançar de novo.`,
        confirmLabel: 'Remover',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) return
      this.impedimentoService.delete(item.id).subscribe({
        next: () => {
          this.snackbar.success('Impedimento removido.')
          this.buscar()
        },
        error: (err: any) => {
          this.snackbar.errorRequest(err)
        },
      })
    })
  }
}
